/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Permissions_AriaInputs */



/**
* | output |
* | --- |
* | "Permissions" |
*
* @param {Explorer_Info_Permissions_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_permissions_aria = /** @type {((inputs?: Explorer_Info_Permissions_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Permissions_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Autorisations")
	if (locale === "de") return /** @type {LocalizedString} */ ("Berechtigungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Permessi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Разрешения")
	if (locale === "es") return /** @type {LocalizedString} */ ("Permisos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("权限")
	if (locale === "ja") return /** @type {LocalizedString} */ ("権限")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुमतियां")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Permissões")
	return /** @type {LocalizedString} */ ("Permissions")
});